import {useTheme} from 'contexts/ThemeContext';
import {
  Image,
  ImageSourcePropType,
  TouchableOpacity,
  Text,
  StyleProp,
} from 'react-native';
import React from 'react';
import {IImage} from 'styles/images';
import styleSheet from './styles';

export interface RectangleImageButtonProps {
  onPress: () => void;
  image: ImageSourcePropType;
  backgroundColor?: string;
  title?: string;
  textStyle?: StyleProp<any>;
  children?: JSX.Element;
  fullImage?: boolean;
  disabled?: boolean;
}

const RectangleImageButton = (props: RectangleImageButtonProps) => {
  const styles = styleSheet(useTheme());

  return (
    <TouchableOpacity
      disabled={props.disabled}
      style={[
        styles.container,
        {
          ...(props.backgroundColor && {
            backgroundColor: props.backgroundColor,
          }),
        },
      ]}
      onPress={props.onPress}>
      {props.title ? (
        <Text style={props.textStyle}>{props.title}</Text>
      ) : (
        <Image
          source={props.image}
          style={props.fullImage ? styles.fullImage : styles.image}
        />
      )}
      {props.children}
    </TouchableOpacity>
  );
};

export default RectangleImageButton;
